export default (store) => {
  store.subscribe((mutation, data) => {
    window.localStorage.setItem('lift', JSON.stringify(data));
  });
}


// WEBPACK FOOTER //
// ./src/store/plugins/local-storage.js